import React from 'react'
import Collection from '../common/collection'

function CollectionV({ props }) {
  return (
    <Collection
      src={['https://volverse-negro-daniel.s3.amazonaws.com/images/21.+ni%C3%B1ocornisa73.jpg']}
      alt="Niño cornisa"
    />
  )
}


export default CollectionV
